// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  apiUrl: 'https://demo-backend.fundcore.com.co/api',
  apiKey: '8D545321C888860595C8FD0C4A6BB3960DE161D46AFA7AEDFEC78D2B30974451',
  apiToken: 'BFFEDBE4ACAEB60BC6F0130F428029C9E2B6BE71268E08FB09EF1792DC713F6A',

  // apiUrl: 'https://backend.fundcore.com.co/api',
  // apiKey: '2D41B257D50A1D2CA2DA413184A524FD04745FE94819D60EB65646214B620180',
  // apiToken: '7AE91CC94592CAD4653E800F2B61E9F0C4559CFF1EEEF3779881B8D3E80172D5',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
